export default __webpack_public_path__ + "static/media/icon-shrimp.f9b7f87f.png";